import { markOAuthFlowStarted } from './oauthCrossTab';

/**
 * Open Google/Microsoft OAuth in a new tab so users can keep this page open for mailbox credentials.
 * @param {{ provider?: string, accountEmail?: string }} [flowMeta] — stored so the OAuth tab can show a completion card
 * @returns {boolean} true if a window was opened
 */
export function openOAuthInNewTab(url, toast, flowMeta) {
  if (flowMeta?.provider) {
    markOAuthFlowStarted({
      provider: flowMeta.provider,
      accountEmail: flowMeta.accountEmail,
    });
  }
  const win = window.open(url, '_blank', 'noopener,noreferrer');
  if (!win) {
    toast?.({
      title: 'Pop-up blocked',
      description: 'Allow pop-ups for this site, then click Connect OAuth again.',
      status: 'warning',
      duration: 8000,
      isClosable: true,
    });
    return false;
  }
  toast?.({
    title: 'Sign-in opened in a new tab',
    description:
      'Complete Google or Microsoft sign-in there. Keep this tab open to copy your mailbox password, app password, or 2FA code.',
    status: 'info',
    duration: 10000,
    isClosable: true,
  });
  return true;
}
